"use client";

import React from "react";
import Box from "@mui/material/Box";

interface WistiaPlayButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
}

/**
 * Authentic Wistia play button component
 * Exact specifications: 107.141px × 68.5703px, primary.main
 */
// eslint-disable-next-line import/prefer-default-export
export const WistiaPlayButton: React.FC<WistiaPlayButtonProps> = ({
  onClick,
  ariaLabel = "Play video"
}) => (
  <Box
    className="wistia-play-button"
    role="button"
    onClick={onClick}
    onKeyDown={(event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClick?.();
      }
    }}
    tabIndex={0}
    data-testid="wistia-play-button"
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "107.141px",
      height: "68.5703px",
      backgroundColor: "primary.main",
      cursor: "pointer",
      transition: "background-color 150ms",
      zIndex: 2,
      "&:hover": {
        backgroundColor: "primary.700"
      }
    }}
    aria-label={ariaLabel}
  >
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 125 80"
      enableBackground="new 0 0 125 80"
      aria-hidden="true"
      style={{
        fill: "var(--theme-palette-common-white)",
        height: "68.5703px",
        left: 0,
        strokeWidth: 0,
        top: 0,
        width: "100%",
        position: "absolute"
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="var(--theme-palette-common-white)"
        opacity="1"
        transform="translate(44, 22)"
        d="M12.138 2.173C10.812 1.254 9 2.203 9 3.817v28.366c0 1.613 1.812 2.563 3.138 1.644l20.487-14.183a2 2 0 0 0 0-3.288L12.138 2.173Z"
      />
    </svg>
  </Box>
);
